import React, { useState, useEffect, useContext } from "react";
import { Dialog } from "primereact";

import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { getInformacionEmpresa } from "../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import { formatNumberDecimal } from "../../../../Base/Services/FormatTemplate";

import { getHabilidades, getResponsabilidades } from "../../../../API/RRHH/Posiciones/PosicionesRequest";

import pdfMake from "pdfmake/build/pdfmake";


const FormatoPosicion = ({ dialogFormato, setDialogFormato, selected, setSelected }) => {

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [formato, setFormato] = useState([]);
  

  const getValoresIniciales = async (selected) => {
    setLoading(true);
    if(selected){

        let IdPosicion = selected[0]?.IdPosicion

        const responsabilidadTempo = await getResponsabilidades(IdPosicion)
        const habilidadesTempo = await getHabilidades(IdPosicion)
        const infoEmpresa = await getInformacionEmpresa()

        GenerarFormato(selected[0], responsabilidadTempo, habilidadesTempo, infoEmpresa[0])
    }
    setLoading(false);
  };

  const tablaLayout = {
    hLineWidth: function (i, node) {
      return i === 0 ? 0 : 0.25;
    },
    vLineWidth: function (i, node) {
      return 0.25;
    },
    hLineColor: function (i, node) {
      return "#44546a"; 
    },
    vLineColor: function (i, node) {
      return "#44546a"; 
    },
  };


  const GenerarFormato = (data, responsabilidades, habilidades, infoEmpresa) => {
    setLoading(true)
    const docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [40, 81, 40, 70],

        header: function (currentPage, pageCount, pageSize) {
            return {
                table: {
                    widths: ['70%', '30%'], 
                    body: [
                        [
                            {
                                text: "DESCRIPTOR DE PUESTO DE TRABAJO",
                                margin: [160, 30, 0, 0],
                                style: 'titulo',
                            },
                            {
                                image: `${infoEmpresa?.LogoPrimarioB64}`,
                                width: 150,
                                margin: [0, -8, 10, 0] 
                            }
                        ]
                    ]
                },
                layout: 'noBorders' 
            }
        },

        footer: (currentPage, pageCount) => {
            return {
                margin: [0, 15, 0, 0],
                table: {
                    widths: ['50%','50%'],
                    body: [
                        [
                            {
                                margin: [34, 0, 0, 0],
                                text: 'Fecha Impresión: ' + new Date().toLocaleString('es-ES'),
                                style: 'footer',
                            },
                            {
                                text: `Pagina ${currentPage} / ${pageCount}`,
                                margin: [0, 0, 35, 0],
                                style: 'footerPag',
                            },
                        ],
                    ],
                },
                layout: {
                defaultBorder: false,
                },
            };
        },
        

        content: [
            // VISIÓN GENERAL DEL TRABAJO
            {
                table: {
                    widths: ["20%",'80%'],
                    body: [
                        [
                            {
                                text: 'VISIÓN GENERAL DEL TRABAJO',
                                style: 'enunciado',
                                fillColor: "#44546a",
                                color: "white",
                                colSpan: 2,
                                border: [true, true, true, false]
                            },{}
                        ],
                        [
                            {
                                text: 'TÍTULO DEL TRABAJO',
                                style: 'enunciadoSimple',
                                border: [true, false, false, true],
                                fillColor: "#44546a",
                                color: "white",
                            },
                            {
                                text: `${data?.Posicion || ''}`,
                                border: [false, false, true, true],
                                style: 'textoGeneral',
                            }
                        ],
                        [
                            {
                                text: 'DEPARTAMENTO',
                                style: 'enunciadoSimple',
                                fillColor: "#44546a",
                                border: [true, false, false, false],
                                color: "white",
                            },
                            {
                                text: `${(data?.Area || '').toUpperCase()}`,
                                border: [false, false, true, true],
                                style: 'textoGeneral',
                            }
                        ],
                        [
                            {
                                text: 'DEPENDENCIA',
                                style: 'enunciadoSimple',
                                fillColor: "#44546a",
                                border: [true, false, false, true],
                                color: "white",
                            },
                            {
                                text: `${data?.Dependencia || ''}`,
                                border: [false, false, true, true],
                                style: 'textoGeneral',
                            }
                        ],
                    ],
                },
                layout: tablaLayout,
            },

            // PERFIL OCUPACIONAL
            {
                margin: [0,10,0,0],
                table: {
                    widths: ["100%"],
                    body: [
                        [
                            {
                                text: 'PERFIL OCUPACIONAL',
                                style: 'enunciado',
                                fillColor: "#44546a",
                                color: "white",
                                border: [true, true, true, false]
                            }
                        ],
                        [
                            {
                                text: `${data?.PerfilOcupacional || ''}`,
                                border: [true, false, true, true],
                                style: 'textoGeneral',
                            }
                        ],
                    ],
                },
                layout: tablaLayout,
            },

            // OBJETIVO DEL PUESTO
            {
                margin: [0,10,0,0],
                table: {
                    widths: ["100%"],
                    body: [
                        [
                            {
                                text: 'OBJETIVO DEL PUESTO',
                                style: 'enunciado',
                                fillColor: "#44546a",
                                color: "white",
                                border: [true, true, true, false]
                            }
                        ],
                        [
                            {
                                text: `${data?.Objetivo || ''}`,
                                border: [true, false, true, true],
                                style: 'textoGeneral',
                            }
                        ],
                    ],
                },
                layout: tablaLayout,
            },

            // EDUCACIÓN Y FORMACIÓN
            {
                margin: [0,10,0,0],
                table: {
                    widths: ["100%"],
                    body: [
                        [
                            {
                                text: 'EDUCACIÓN Y FORMACIÓN',
                                style: 'enunciado',
                                fillColor: "#44546a",
                                color: "white",
                                border: [true, true, true, false]
                            }
                        ],
                        [
                            {
                                text: `${data?.Educacion || ''}`,
                                border: [true, false, true, true],
                                style: 'textoGeneral',
                            }
                        ],
                    ],
                },
                layout: tablaLayout,
            },

            // CONOCIMIENTO Y EXPERIENCIA
            {
                margin: [0,10,0,0],
                table: {
                    widths: ["100%"],
                    body: [
                        [
                            {
                                text: 'CONOCIMIENTO Y EXPERIENCIA',
                                style: 'enunciado',
                                fillColor: "#44546a",
                                color: "white",
                                border: [true, true, true, false]
                            }
                        ],
                        [
                            {
                                text: `${data?.Conocimiento || ''}`,
                                border: [true, false, true, true],
                                style: 'textoGeneral',
                            }
                        ],
                    ],
                },
                layout: tablaLayout,
            },
            
            // HABILIDADES, DESTREZAS Y REQUISITOS
            {
                margin: [0,10,0,0],
                table: {
                    widths: ["100%"],
                    body: [
                        [
                            {
                                text: 'HABILIDADES, DESTREZAS Y REQUISITOS',
                                style: 'enunciado',
                                fillColor: "#44546a",
                                color: "white",
                                border: [true, true, true, false]
                            }
                        ],
                        ...(habilidades?.map(habilidad => [
                            {
                                text: habilidad?.Habilidad,
                                border: [true, false, true, false],
                                style: 'textoGeneral',
                            }
                        ]) || []),
                        [
                            {
                                text: '',
                                color: "white",
                                border: [false, true, false, false]
                            }
                        ],
                    ],
                },
                layout: tablaLayout,
            },

            // DEBERES Y RESPONSABILIDADES
            {
                margin: [0,8,0,0],
                table: {
                    widths: ["3%",'97%'],
                    body: [
                        [
                            {
                                text: 'DEBERES Y RESPONSABILIDADES',
                                style: 'enunciado',
                                fillColor: "#44546a",
                                color: "white",
                                colSpan: 2,
                                border: [true, true, true, true]
                            },{}
                        ],
                        ...(responsabilidades?.map((responsabilidad, index) => [
                            {
                                text: `${index + 1}`, 
                                style: 'enunciadoSimple',
                                border: [true, false, false, false],
                                fillColor: "#44546a",
                                color: "white",
                            },
                            {
                                text: responsabilidad?.Responsabilidad,
                                border: [false, false, true, true],
                                style: 'textoGeneral',
                            }
                        ]) || [])
                    ],
                },
                layout: tablaLayout,
            },

            // CONDICIONES DE TRABAJO
            {
                margin: [0,10,0,0],
                table: {
                    widths: ["20%",'80%'],
                    body: [
                        [
                            {
                                text: 'CONDICIONES DE TRABAJO',
                                style: 'enunciado',
                                fillColor: "#44546a",
                                color: "white",
                                colSpan: 2,
                                border: [true, true, true, true]
                            },{}
                        ],
                        [
                            {
                                text: `HORAS / TURNOS`, 
                                style: 'enunciadoSimple',
                                border: [true, false, false, false],
                                fillColor: "#44546a",
                                color: "white",
                            },
                            {
                                text: `Horarios de Producción`, 
                                style: 'textoGeneral',
                                border: [false, false, true, true],
                            }
                        ],
                        [
                            {
                                text: `RANGO  DE SALARIO`, 
                                style: 'enunciadoSimple',
                                border: [true, false, false, false],
                                fillColor: "#44546a",
                                color: "white",
                            },
                            {
                                text: `${formatNumberDecimal(data?.RangoSalario) || ''}`, 
                                style: 'textoGeneral',
                                border: [false, false, true, true],
                            }
                        ],
                        [
                            {
                                text: `BENEFICIOS`, 
                                style: 'enunciadoSimple',
                                border: [true, false, false, false],
                                fillColor: "#44546a",
                                color: "white",
                            },
                            {
                                text: `${data?.Beneficios}`, 
                                style: 'textoGeneral',
                                border: [false, false, true, true],
                            }
                        ],
                    ],
                },
                layout: tablaLayout,
            },

            // FIRMAS
            {
                margin: [0,10,0,0],
                table: {
                    widths: ["20%",'80%'],
                    body: [
                        [
                            {
                                text: 'FIRMAS',
                                style: 'enunciado',
                                fillColor: "#44546a",
                                color: "white",
                                colSpan: 2,
                                border: [true, true, true, true]
                            },{}
                        ],
                        [
                            {
                                text: `AUTORIZADO`, 
                                style: 'enunciadoSimple',
                                border: [true, false, false, false],
                                fillColor: "#44546a",
                                color: "white",
                            },
                            {
                                text: ``, 
                                style: 'textoGeneral',
                                border: [false, false, true, true],
                            }
                        ],
                        [
                            {
                                text: `RECURSOS HUMANOS`, 
                                style: 'enunciadoSimple',
                                border: [true, false, false, false],
                                fillColor: "#44546a",
                                color: "white",
                            },
                            {
                                text: ` `, 
                                style: 'textoGeneral',
                                border: [false, false, true, true],
                            }
                        ],
                        [
                            {
                                text: `FECHA REVISIÓN`, 
                                style: 'enunciadoSimple',
                                border: [true, false, false, false],
                                fillColor: "#44546a",
                                color: "white",
                            },
                            {
                                text: `${data?.FechaRevisionStr || ''}`, 
                                style: 'textoGeneral',
                                border: [false, false, true, true],
                            }
                        ],
                    ],
                },
                layout: tablaLayout,
            },
        ],
        

        styles: {
            titulo: {
              fontSize: 13,
              bold: true,
              alignment: "center",
            },
            enunciado: {
                fontSize: 10,
                bold: true,
                alignment: "center",
            },
            enunciadoSimple: {
                fontSize: 10,
                alignment: "right",
            },
            textoGeneral: {
                fontSize: 10,
                alignment: "justify",
            },
            footer: {
                fontSize: 8,
                alignment: "justify",
            },
            footerPag: {
                fontSize: 8,
                alignment: "right",
            },
        },
    }

    const doc = pdfMake.createPdf(docDefinition);

    doc.getDataUrl((url) =>{ setFormato(url) })
    setLoading(false)
  }

  const onHide = () => {
    setDialogFormato(false);
    setSelected([])
  };

  useEffect(() => {
    if (dialogFormato) {
      getValoresIniciales(selected);
    }
  }, [dialogFormato]);

  return (
    <div>
      <Dialog
        visible={dialogFormato}
        onHide={onHide}
        style={{ width: "63vw", height: "85vh" }}
      >
        <Loader loading={loading} querySelector='FormatoDialog' />
        <div id="FormatoDialog">
          {!loading && formato && (
            <iframe
              src={formato}
              style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
              id="foo"
            />
          )}
        </div>
      </Dialog>
      
    </div>
  );
};

export default FormatoPosicion;
